"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoggers = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var logState = {
  attributeUpdateStart: -1,
  attributeManagerUpdateStart: -1,
  attributeUpdateMessages: []
};
var LOG_LEVEL_MAJOR_UPDATE = 1;
var LOG_LEVEL_MINOR_UPDATE = 2;
var LOG_LEVEL_UPDATE_DETAIL = 3;
var LOG_LEVEL_INFO = 4;
var LOG_LEVEL_DRAW = 2;

var getLoggers = function getLoggers(log) {
  return {
    'layer.changeFlag': function layerChangeFlag(layer, key, flags) {
      log.log(LOG_LEVEL_UPDATE_DETAIL, "".concat(layer.id, " ").concat(key, ": "), flags[key])();
    },
    'layer.initialize': function layerInitialize(layer) {
      log.log(LOG_LEVEL_MAJOR_UPDATE, "Initializing ".concat(layer))();
    },
    'layer.update': function layerUpdate(layer, needsUpdate) {
      if (needsUpdate) {
        var flags = layer.getChangeFlags();
        log.log(LOG_LEVEL_MINOR_UPDATE, "Updating ".concat(layer, " because: ").concat(Object.keys(flags).filter(function (key) {
          return flags[key];
        }).join(', ')))();
      } else {
        log.log(LOG_LEVEL_INFO, "".concat(layer, " does not need update"))();
      }
    },
    'layer.matched': function layerMatched(layer, changed) {
      if (changed) {
        log.log(LOG_LEVEL_INFO, "Matched ".concat(layer, ", state transfered"))();
      }
    },
    'layer.finalize': function layerFinalize(layer) {
      log.log(LOG_LEVEL_MAJOR_UPDATE, "Finalizing ".concat(layer))();
    },
    'compositeLayer.renderLayers': function compositeLayerRenderLayers(layer, updated, subLayers) {
      if (updated) {
        log.log(LOG_LEVEL_MINOR_UPDATE, "Composite layer rendered new subLayers ".concat(layer), subLayers)();
      } else {
        log.log(LOG_LEVEL_INFO, "Composite layer reused subLayers ".concat(layer), subLayers)();
      }
    },
    'layerManager.setLayers': function layerManagerSetLayers(layerManager, updated, layers) {
      if (updated) {
        log.log(LOG_LEVEL_MINOR_UPDATE, "Updating ".concat(layers.length, " deck layers"))();
      }
    },
    'layerManager.activateViewport': function layerManagerActivateViewport(layerManager, viewport) {
      log.log(LOG_LEVEL_UPDATE_DETAIL, 'Viewport changed', viewport)();
    },
    'attributeManager.invalidate': function attributeManagerInvalidate(attributeManager, trigger, attributeNames) {
      log.log(LOG_LEVEL_MAJOR_UPDATE, attributeNames ? "invalidated attributes ".concat(attributeNames, " (").concat(trigger, ") for ").concat(attributeManager.id) : "invalidated all attributes for ".concat(attributeManager.id))();
    },
    'attributeManager.updateStart': function attributeManagerUpdateStart(attributeManager) {
      logState.attributeUpdateMessages.length = 0;
      logState.attributeManagerUpdateStart = Date.now();
    },
    'attributeManager.updateEnd': function attributeManagerUpdateEnd(attributeManager, numInstances) {
      var timeMs = Math.round(Date.now() - logState.attributeManagerUpdateStart);
      log.groupCollapsed(LOG_LEVEL_MINOR_UPDATE, "Updated attributes for ".concat(numInstances, " instances in ").concat(attributeManager.id, " in ").concat(timeMs, "ms"))();

      var _iterator = _createForOfIteratorHelper(logState.attributeUpdateMessages),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var updateMessage = _step.value;
          log.log(LOG_LEVEL_UPDATE_DETAIL, updateMessage)();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      log.groupEnd(LOG_LEVEL_MINOR_UPDATE)();
    },
    'attribute.updateStart': function attributeUpdateStart(attribute) {
      logState.attributeUpdateStart = Date.now();
    },
    'attribute.allocate': function attributeAllocate(attribute, numInstances) {
      var message = "".concat(attribute.id, " allocated ").concat(numInstances);
      logState.attributeUpdateMessages.push(message);
    },
    'attribute.updateEnd': function attributeUpdateEnd(attribute, numInstances) {
      var timeMs = Math.round(Date.now() - logState.attributeUpdateStart);
      var message = "".concat(attribute.id, " updated ").concat(numInstances, " in ").concat(timeMs, "ms");
      logState.attributeUpdateMessages.push(message);
    },
    'deckRenderer.renderLayers': function deckRendererRenderLayers(deckRenderer, renderStats, opts) {
      var pass = opts.pass,
          redrawReason = opts.redrawReason,
          stats = opts.stats;

      var _iterator2 = _createForOfIteratorHelper(renderStats),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var status = _step2.value;
          var totalCount = status.totalCount,
              visibleCount = status.visibleCount,
              compositeCount = status.compositeCount,
              pickableCount = status.pickableCount;
          var primitiveCount = totalCount - compositeCount;
          var hiddenCount = primitiveCount - visibleCount;
          log.log(LOG_LEVEL_DRAW, "RENDER #".concat(deckRenderer.renderCount, "   ").concat(visibleCount, " (of ").concat(totalCount, " layers) to ").concat(pass, " because ").concat(redrawReason, "   (").concat(hiddenCount, " hidden, ").concat(compositeCount, " composite ").concat(pickableCount, " pickable)"))();

          if (stats) {
            stats.get('Redraw Layers').add(visibleCount);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  };
};

exports.getLoggers = getLoggers;
//# sourceMappingURL=loggers.js.map